import React, { useState, useEffect } from "react";
import {
  Box,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  ListItem,
  Divider,
  // Link,
  Stack,
} from "@common-ui/ui";
import { getCustomerPlaces } from "../../services/customer";
import { getOrgPlaces } from "../../services";
import { PlacesTreeView } from "./PlacesTreeView";
// import { ChevronRight } from "@mui/icons-material";
export const SelectionView = ({
  item,
  setSelection,
  setPlaces,
  places,
  placesParent,
  setPlacesParent,
}) => {
  const [loadPlaces, setLoadPlaces] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  async function init() {
    try {
      if (item.system_id) {
        let placesData = await getCustomerPlaces(item.org, item.system_id);
        placesData = [
          {
            system_id: "NONE",
            parent: null,
            name: "None",
            address: null,
            contact_name: null,
            contact_email: null,
            contact_phone: null,
            notes: null,
            child_places: [],
          },
          ...placesData,
        ];
        setLoadPlaces(placesData);
      } else {
        let placesData = await getOrgPlaces(item.id);
        placesData = [
          {
            system_id: "NONE",
            parent: null,
            name: "None",
            address: null,
            contact_name: null,
            contact_email: null,
            contact_phone: null,
            notes: null,
            child_places: [],
          },
          ...placesData,
        ];
        setLoadPlaces(placesData);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setLoadPlaces([]);
      // alert(error);
    }
  }
  return (
    <>
      {/* <Divider sx={{ mt: 2 }} /> */}
      <Box sx={{ px: 2 }}>
        {/* <Typography align="right">
          <Link
            sx={{ my: 1 }}
            component="button"
            onClick={() => {
              // dispatch(clearCustomerAndPlaces());
              setSelection(null);
              setPlaces([]);
              setPlacesParent(undefined);
            }}
          >
            Clear
          </Link>
        </Typography> */}
        {/* {item?.id ? (
          <Typography variant="h6">Internal Clients</Typography>
        ) : (
        
          <Typography variant="h6">External Clients</Typography>
        )} */}
        <ListItem
          component="div"
          // disablePadding
          sx={{
            bgcolor: "rgba(238,245,251, 1)",
            height: 64,
            border: "1px solid #DFDFDF",
            // (theme) => theme.palette.blue[200]
          }}
        >
          <ListItemAvatar>
            <Avatar
              alt={item.name}
              src={`https://avatars.dicebear.com/v2/initials/${item.name}.svg?chars=2`}
            />
          </ListItemAvatar>
          <ListItemText
            primary={
              <Typography variant="body1" fontWeight="700">
                {item?.name}
              </Typography>
            }
            disablePadding
            secondary={
              item?.system_id ? (
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.secondary"
                  >
                    {item?.account ? `Account - ${item?.account}` : ""}
                  </Typography>{" "}
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Typography
                    sx={{ display: "inline" }}
                    component="span"
                    variant="body2"
                    color="text.secondary"
                  >
                    {/* ID - {item?.id || "None"} */}
                  </Typography>
                </React.Fragment>
              )
            }
          />
          <Stack direction={"row"} alignItems="center">
            <Stack direction="column" spacing={1}>
              <Typography variant="body2" color="text.secondary">
                {item?.email}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {item?.phone}
              </Typography>
            </Stack>
          </Stack>
        </ListItem>
      </Box>
      <Divider sx={{ my: 2 }} />
      <Box
        component="main"
        sx={{
          // width: "100%",
          // maxWidth: "100%",
          height: 400,
          bgcolor: "background.paper",
          px: 2,
        }}
      >
        <Typography fontSize="14px" fontWeight="700" variant="h6">
          Places
        </Typography>

        {isLoading ? "Loading..." : ""}
        {!isLoading && !loadPlaces.length ? (
          "No Data"
        ) : (
          <Box sx={{ bgcolor: "#F8F8F8", border: "1px solid #EBEBEB" }}>
            <PlacesTreeView
              data={loadPlaces}
              setPlaces={setPlaces}
              places={places}
              placesParent={placesParent}
              setPlacesParent={setPlacesParent}
            />
          </Box>
        )}
      </Box>
    </>
  );
};
